import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
// --- Import redux
import { connect } from "react-redux";
// --- Import coponents
import Auth from "../../pages/Auth/Auth";

function LoginRoute({ isAuth, homeRoute, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) => {
        return isAuth ? (
          <Redirect
            to={{
              pathname: homeRoute,
              search: location.search,
              state: { from: location },
            }}
          />
        ) : (
          <Auth />
        );
      }}
    />
  );
}

LoginRoute.propTypes = {
  isAuth: PropTypes.bool.isRequired,
  homeRoute: PropTypes.string.isRequired,
};
const mapDispatchToProps = {};

const mapStateToProps = (state) => {
  return {
    isAuth: state.userDataStore.isAuth,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginRoute);
